<template>
  <IonPage>
    <div
      class="map-container"
      :class="map.modalExpandState === 1 ? 'modal-one' : map.modalExpandState === 3 ? 'modal-three' : ''"
    >
      <IonFab
        @click="
          locationStore.loadingCoordinates
            ? null
            : map.focusOnUserLocation({ alertOnFailure: true, skipAnimation: false })
        "
        slot="fixed"
        vertical="bottom"
        horizontal="end"
        class="mb-[20px]"
      >
        <IonFabButton size="small" color="white">
          <IonSpinner name="lines-small" v-if="locationStore.loadingCoordinates" color="primary"></IonSpinner>
          <i v-else class="icon-navigation text-blue-500"></i>
        </IonFabButton>
      </IonFab>
      <div id="theMapEl" ref="mapEl"></div>
    </div>
    <IonRouterOutlet
      class="map-modal-container"
      :class="map.modalExpandState === 1 ? 'modal-one' : map.modalExpandState === 3 ? 'modal-three' : ''"
    ></IonRouterOutlet>
  </IonPage>
</template>

<script setup lang="ts">
import { IonFab, IonFabButton, IonPage, IonRouterOutlet, IonSpinner } from '@ionic/vue';
import { useTemplateRef, watch } from 'vue';
import { useLocation } from '@/stores/location.store';
import { useNewMap } from '@/stores/map/map.store';

const map = useNewMap();
const locationStore = useLocation();
const mapEl = useTemplateRef('mapEl');

watch(mapEl, (el) => map.init(el));
</script>

<style scoped>
.map-container {
  position: relative;
  height: var(--map-medium-height);
  transition: all 0.3s ease;
}
.map-container.modal-three {
  height: var(--map-small-height);
}
.map-container.modal-one {
  height: var(--map-large-height);
}
.map-modal-container {
  box-shadow: 0px -5px 10px rgba(0, 0, 0, 0.2);
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: calc(var(--map-medium-height) - 30px);
  transition: all 0.3s ease;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  overflow: hidden;
  background: white;
  display: flex;
  flex-direction: column;
}
.map-modal-container.modal-three {
  top: calc(var(--map-small-height) - 30px);
}
.map-modal-container.modal-one {
  top: calc(var(--map-large-height) - 30px);
}
#theMapEl {
  display: inline-block;
  width: 100%;
  height: 100%;
}
</style>
